// extracted by mini-css-extract-plugin
module.exports = {"packageLabel":"planlabel_packageLabel__CWgRm"};